import { Router } from '@angular/router';
import { Component, Input, OnInit, EventEmitter, Output, WritableSignal } from '@angular/core';
import { RightService } from '@service/right.service';

@Component({
    selector: 'documentdetailversion',
    templateUrl: 'documentdetailversion.component.html',
    styleUrls: ['documentdetailversion.component.scss'],
})
export class DocumentDetailVersionComponent implements OnInit {
    @Input() public rightService: RightService;
    @Input() public viewIndex = 0;
    @Input() public docInfos: any[];
    @Input() public docIndexFiltered: any[];
    @Input() public docVersion: WritableSignal<any[]>;   
    @Input() public currentDocId: string = '';
    @Input() public isLock;
    @Input() public numVer: string = '';
    @Input() public nbZoneDisplay;
    @Output() public onUpdateVer = new EventEmitter<any>();
    @Output() public onViewVer = new EventEmitter<any>();

    constructor(private router: Router) {}

    public ngOnInit() {
    }

    public handleChange($event) {
        this.viewIndex = $event.index;
        this.resetOutlet();
    }

    public resetOutlet() {
        let wUrl = this.router.url;
        if (wUrl.substring(0, 19) === '/page-basket-detail') {
            this.router.navigate(['/page-basket-detail']);
        }
    }

    public viewVer(event) {
        this.onViewVer.emit(event);
    }
    
    public refreshVer(event) {
        this.onUpdateVer.emit(event);
    }

    public getNumVer() {
        return this.numVer.substring(5, 9);
    }
}
